import Module from '../../Module';
import services from 'core/services';

class AddressService extends Module {
  get baseURL() {
    return '/api/v1/addresses'
  }

  parseAddressables(addresses) {
    return addresses.map(address => {
      return this.parseAddressable(address)
    })
  }

  parseAddressable(address) {
    return {
      address: address.address ? this.parseAddress(address.address) : [],
      addressId: address.addressId,
      createdAt: address.createdAt,
      deletedAt: address.deletedAt,
      id: address.id,
      ownerId: address.ownerId,
      ownerType: address.ownerType,
      updatedAt: address.updatedAt,
    }
  }

  parseAddress(address) {
    return {
      cityId: address.cityId,
      createdAt: address.createdAt,
      deletedAt: address.deletedAt,
      id: address.id,
      phone: address.phone,
      phoneId: address.phoneId,
      postalCode: address.postalCode,
      temp: address.temp,
      text: address.text,
      title: address.title,
      updatedAt: address.updatedAt,
      city: address.city ? this.parseCity(address.city) : null,
      locationId: address?.location_id,
      location: address?.location
    }
  }

  parseCity(city) {
    return {
      createdAt: city.createdAt,
      deletedAt: city.deletedAt,
      id: city.id,
      name: city.name,
      prefix: city.prefix,
      provinceId: city.provinceId,
      updatedAt: city.updatedAt,
      province: city.province ? this.parseProvince(city.province) : null,
    }
  }

  parseProvince(province) {
    return {
      cities: province.cities,
      createdAt: province.createdAt,
      deletedAt: province.deletedAt,
      id: province.id,
      name: province.name,
      updatedAt: province.updatedAt,
    }
  }

  getAddresses(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              addresses: this.parseAddressables(data.addressables)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponseError(e))
        })
    })
  }

  addAddress(model, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}`, {
          data: model,
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              addresses: this.parseAddressable(data.addressable)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  getAddress(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}`, {
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              addresses: this.parseAddressable(data.addressable)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  editAddress(id, model, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .put(`${this.baseURL}/${id}`, {
          data: model,
          params: params
        })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              addresses: this.parseAddressable(data.addressable)
            }))
          )
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }

  deleteAddress(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .delete(`${this.baseURL}/${id}`, {
          params: params
        })
        .then(r => {
          resolve(r)
        })
        .catch(e => {
          reject(this.parseResponse(e))
        })
    })
  }
}

export default new AddressService()
